import { useContext, useState, useEffect } from 'react'
import Section from './_Section'
import ButtonEl from '../helpers/ctas/Button'
import { detectShadeClash, transformPaddingToTailwind } from '../../helpers/style'
import { CheckIcon } from '@heroicons/react/24/solid'
import TitleBlock from '../helpers/TitleBlock'
import RatesCalloutBlock from '../helpers/RatesCalloutBlock'
import { MarkupContext } from '../../providers/Markup'

const ProductFiftyFiftyContent = (props) => {
  const { createMarkup, getPaletteColor } = useContext(MarkupContext)
  const [highlightColor, setHighlightColor] = useState('secondary')
  useEffect(() => {
    if (detectShadeClash(props.backgroundColor, getPaletteColor('secondary'))) {
      setHighlightColor('primary')
    }
  }, [])

  const componentPadding = transformPaddingToTailwind(props.componentPadding, true)
  
  // Handle content alignment (left/center/right) from Component Configuration
  const alignment = props.contentAlignment?.toLowerCase() || 'left'
  const textAlignClass = alignment === 'center' ? 'text-center' : alignment === 'right' ? 'text-right' : 'text-left'

  return (
    <Section type="product5050" innerClass={`max-w-none ${componentPadding.top}`} sectionTitle={false} {...props}>
      {(props.title || props.description) && (
        <div className={`container mx-auto ${componentPadding.mid} ${textAlignClass}`}>
          <TitleBlock headingClass={`w-full `} {...props} />
        </div>
      )}
      <div
        className={`${componentPadding.card} ${componentPadding.bottom} grid lg:grid-cols-2 grid-flow-row-dense grid-flow-col grid-rows-[repeat(10,auto)] lg:max-w-[90%] xl:max-w-[75%] 2xl:max-w-[60%] mx-auto  justify-center before:block before:absolute before:-bottom-px before:left-0 before:w-screen content-[''] before:h-[25%] before:z-[-1] before:bg-white`}
      >
        {(props.contentBlockItems || []).map((item, i) => {
          const col = i + 1
          // Determine alignment classes for button container
          const justifyClass = alignment === 'center' ? 'justify-center' : alignment === 'right' ? 'justify-end' : 'justify-start'
          
          return (
            <div key={i} className="grid border-2 bg-white text-light text-shadow-off rounded-3xl max-w-[65ch] shadow-2xl grid-rows-subgrid row-span-5 mx-8 p-8 mb-6 mt-0">
              {item.title && <div className={`row-1 font-bold text-lg ${textAlignClass}`}>{item.title}</div>}

              {item.description && (
                <div
                  className={`row-2 text-sm mt-2 ${textAlignClass}`}
                  data-rte="true"
                  dangerouslySetInnerHTML={createMarkup(item.description)}
                />
              )}

              {item.product?.variants?.length > 0 && (
                <div
                  className={`row-3 ${item.ctaLink?.length > 0 || (item.description && item.ctaLink?.length < 1) ? 'mt-8' : ''}`}
                >
                  <RatesCalloutBlock backgroundColor="transparent" rate={item.product} idx={0} />
                </div>
              )}

              {item.ctaLink?.length > 0 && (
                <div className={`row-4 flex ${justifyClass} mt-6`}>
                  <ButtonEl
                    link={item.ctaLink[0]?.link}
                    theme={item.ctaLink[0]?.linkType?.toLowerCase() || 'primary'}
                  />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </Section>
  )
}

export default ProductFiftyFiftyContent
